/** Invalidates outstanding invitation reads when the user answers/dismisses.
 * A generation matters as well as busy: reads may finish AFTER the action. */
export class IncomingCallGate {
  private generation = 0;
  busy = false;
  snapshot() { return this.generation; }
  isCurrent(generation: number) { return !this.busy && generation === this.generation; }
  begin() {
    if (this.busy) return false;
    this.busy = true;
    this.generation++;
    return true;
  }
  finish() { this.generation++; this.busy = false; }
  invalidate() { this.generation++; }
}
